var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusNotOkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c63418;}.b{fill:none;}.c{isolation:isolate;}.d{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10,
    cy: 10,
    r: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-283.963 -408.359)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M292.168,418.778a1.144,1.144,0,1,1,0,2.284,1.143,1.143,0,1,1,0-2.284Zm-.889-1.63-.225-4.7a1.107,1.107,0,0,1,2.214,0l-.211,4.7a.87.87,0,0,1-.889.793A.86.86,0,0,1,291.279,417.148Z",
    transform: "translate(0 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusNotOkIcon);
export default __webpack_public_path__ + "static/media/statusNotOkIcon.7589457d038bec60439b396723f96829.svg";
export { ForwardRef as ReactComponent };